import { characters } from '../data/characters';

// Get frequency level based on original index (position in frequency list)
export const getFrequencyLevel = (originalIndex) => {
  if (originalIndex < 100) return { level: 1, label: 'T1', color: '#22c55e', desc: '核心' };      // Core
  if (originalIndex < 200) return { level: 2, label: 'T2', color: '#84cc16', desc: '高频' };      // High
  if (originalIndex < 300) return { level: 3, label: 'T3', color: '#eab308', desc: '常用' };      // Common
  if (originalIndex < 500) return { level: 4, label: 'T4', color: '#f97316', desc: '中频' };      // Medium
  if (originalIndex < 700) return { level: 5, label: 'T5', color: '#ef4444', desc: '扩展' };      // Extended
  return { level: 6, label: 'T6', color: '#a855f7', desc: '进阶' };                               // Advanced
};

// Add original index to each character for frequency tracking
export const charactersWithIndex = characters.map((char, index) => ({ ...char, originalIndex: index }));

// Weighted shuffle - higher frequency characters appear more often
// Creates a deck where T1 chars appear ~3x more than T6 chars
export const createWeightedDeck = (chars, isPro = false) => {
  const weighted = [];

  // Filter for free users: only top 150 characters
  const availableChars = isPro ? chars : chars.filter(c => c.originalIndex < 150);

  availableChars.forEach(char => {
    const idx = char.originalIndex;
    // Weight: T1 gets 6 copies, T2 gets 5, T3 gets 4, T4 gets 3, T5 gets 2, T6 gets 1
    let copies;
    if (idx < 100) copies = 6;       // T1 - Core
    else if (idx < 200) copies = 5;  // T2 - High frequency
    else if (idx < 300) copies = 4;  // T3 - Common
    else if (idx < 500) copies = 3;  // T4 - Medium
    else if (idx < 700) copies = 2;  // T5 - Extended
    else copies = 1;                  // T6 - Advanced

    for (let i = 0; i < copies; i++) {
      weighted.push(char);
    }
  });

  // Shuffle the weighted array
  for (let i = weighted.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [weighted[i], weighted[j]] = [weighted[j], weighted[i]];
  }

  // Remove consecutive duplicates (same character back-to-back)
  const result = [];
  let lastChar = null;
  const skipped = [];

  for (const char of weighted) {
    if (char.char !== lastChar) {
      result.push(char);
      lastChar = char.char;
    } else {
      skipped.push(char);
    }
  }

  // Reinsert skipped chars at random non-consecutive positions
  for (const char of skipped) {
    let inserted = false;
    let attempts = 0;
    while (!inserted && attempts < 50) {
      const pos = Math.floor(Math.random() * (result.length + 1));
      const before = pos > 0 ? result[pos - 1]?.char : null;
      const after = result[pos]?.char;
      if (before !== char.char && after !== char.char) {
        result.splice(pos, 0, char);
        inserted = true;
      }
      attempts++;
    }
    // If can't find good spot after 50 tries, just append
    if (!inserted) result.push(char);
  }

  return result;
};

// Simple shuffle for fallback
export const shuffleArray = (array) => {
  const newArray = [...array];
  for (let i = newArray.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [newArray[i], newArray[j]] = [newArray[j], newArray[i]];
  }
  return newArray;
};
